var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rejectsAnalyse"},[_c('div',{staticClass:"top"},[_c('div',{staticClass:"title"},[_c('div',{staticClass:"circle"},[_c('div',{staticClass:"circle_1"})]),_vm._v(" 不良品分析 ")])]),_c('div',{staticClass:"bottom"},[_c('div',{staticStyle:{"width":"100%","height":"100%"},attrs:{"id":"rejectPie"}})])])
}]

export { render, staticRenderFns }